import FileSaver from 'file-saver';
import authTokenUtil from '../../account/authTokenUtil';

export default async function download(url: string, filename: string) {
  const authToken = authTokenUtil.get();
  const headers = authToken ? { Authorization: authToken } : undefined;
  const res = await fetch(url, { method: 'GET', headers });
  if (!res.ok) {
    throw new Error(res.statusText);
  }
  const blob = await res.blob();
  FileSaver.saveAs(blob, filename);
}
